import React from 'react';
import styles from './TabsContent.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const BioDescription = () => {
  return (
    <div className={styles.container}>
      <p className={styles.mainTitle}>Cazane pe tocatură și rumeguș <span className={styles.highlight}>Bio</span></p>
      <p className={styles.text}>
        Cazanele cu funcționare pe tocatură și rumeguș, modelul BIO, sunt concepute pentru încălzirea caselor, clădirilor rezidențiale și industriale, înzestrate cu regim automat.
        Combustibilul este alimentat automat cu ajutorul șnecului din buncăr, care se așează lângă cazan.
      </p>
      <p className={styles.text}>
        Cazanele fixe și centralele modul sunt folosite pentru sistemele de încălzire închise.
      </p>
      <p className={styles.text}>
        Combustibilul pentru cazane poate fi deșeu lemnos, rumeguș și tocatură lemnoasă cu fracția maximă de 15x35x80 mm.
      </p>
      <div className={styles.guaranteeBox}>
        <div className={styles.guaranteeContent}>
          <i className="fa-solid fa-circle-plus fa-2x" />
          <p>Pentru a trece cazanul la alimentare manuală a combustibilului solid, este necesar sa comandați de la producător un grătar din fontă.</p>
        </div>
      </div>
      <h1 className={styles.title}>Caracteristici</h1>
      <p className={styles.text}>
        Pentru a proteja împotriva pierderilor, pe suprafața exterioară a cazanului, sub carcasa decorativă avem un strat de material izolant termic.
      </p>
      <p className={styles.text}>
        Ușile cazanelor au paravane reglabil și un cablu de etanșare, care garantează o fixare strânsă a ușii pe corpul cazanului, astfel evitând pătrunderea gazelor arse în casă și asigurând etanșeitatea completă a camerei de ardere.
      </p>
      <p className={styles.text}>
        Combustibilul pentru procesul de ardere este alimentat automat din buncărul cu combustibil, situat lângă cazan, utilizând un mecanism de alimentare cu șnec. În buncăr se află un mecanism de amestecare a combustibilului cu ajutorul unui motor-reductor. Pe grătarul din cuptorul cazanului are loc procesul de ardere a combustibilului cu ajutorul aerului, furnizat de ventilatoare.
      </p>
      <p className={styles.text}>
        Aerul este furnizat prin duzele situate deasupra și sub grătarul din țevi, pentru arderea completă a gazelor secundare. Partea convexă constă din două rânduri de țevi în jar. O altă caracteristică a modelului BIO este camera de ardere căptușită cu cărămizi de ceramică. Aceasta calitate asigură o eficiență mare a cazanului.
      </p>
      <p className={styles.text}>
        Acest model de cazan oferă posibilitatea conectării buncărului cu sistem mecanic de alimentare, atât în stânga cazanului, cât și în dreapta lui, în funcție de preferințele clientului.
      </p>
      <p className={styles.text}>
        Buncărul are 2 guri, cea superioară este pentru alimentarea acestuia și cea inferioară pentru curățarea lui. În lateral se află o fereastră prin care putem urmări nivelul combustibilului din buncăr fără a fi nevoie să-l deschidem. Gazele arse sunt eliminate prin burlanul de evacuare care se unește la gura de evacuare de formă rotundă, aflată în spatele cazanului.
      </p>
      <h2 className={styles.subtitle}>Întreținerea cazanului</h2>
      <p className={styles.text}>
        Întreținerea funcției cazanului constă în adăugarea periodică a combustibilului în buncăr și înlăturarea cenușii din partea inferioară a acestuia fără a fi necesară stingerea focului din cazan.
      </p>
      <p className={styles.text}>
        După aprinderea cazanului nu este necesară supravegherea permanentă a acestuia. Exploatarea cazanului se poate face neîntrerupt pe toată perioada sezonului de încălzire. Cazanul pe rumeguș, de exemplu, este ideal pentru sistemele de încălzire și alimentarea apei calde legat de un boiler.
      </p>
      <p className={styles.text}>
        O supapă termostat este furnizată împreună cu cazanul, care trebuie montată pe un loc special pe buncăr. Senzorul supapei măsoară în continuu temperatura din buncărul cu combustibil, iar în cazul valorilor ridicate semnalizează arderea combustibilului în conducta dintre buncăr și retortă.
      </p>
      <div className={styles.guaranteeBox}>
        <div className={styles.guaranteeContent}>
          <i className="fa-solid fa-coins" />
          <p>Cazanele pe tocătură , rumeguș și tors modelul <span className={styles.highlight}>Bio</span> – este cea mai buna soluție a întreprinderilor moderne care doresc sa reducă în mod semnificativ costurile de încălzire, oferind în același timp condiții confortabile în incinta acestora.</p>
        </div>
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Parametri</th>
              <th>U.M.</th>
              <th>95 kW</th>
              <th>150 kW</th>
              <th>200 kW</th>
              <th>250 kW</th>
              <th>300 kW</th>
              <th>400 kW</th>
              <th>500 kW</th>
              <th>600 kW</th>
              <th>700 kW</th>
              <th>800 kW</th>
              <th>1000 kW</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Eficiența, min</td>
              <td>%</td>
              <td colSpan="11">86</td>
            </tr>
            <tr>
              <td>Volumul apei din cazan</td>
              <td>m³</td>
              <td>0.3</td>
              <td>0.5</td>
              <td>0.6</td>
              <td>0.8</td>
              <td>1.0</td>
              <td>1.2</td>
              <td>1.5</td>
              <td>1.9</td>
              <td>2.0</td>
              <td>2.2</td>
              <td>2.8</td>
            </tr>
            <tr>
              <td>Greutatea cazanului, fără apă</td>
              <td>kg</td>
              <td>1200</td>
              <td>1250</td>
              <td>1450</td>
              <td>1800</td>
              <td>2680</td>
              <td>3330</td>
              <td>3900</td>
              <td>3900</td>
              <td>4100</td>
              <td>4500</td>
              <td>4850</td>
            </tr>
            <tr>
              <td>Volumul buncăr</td>
              <td>m³</td>
              <td colSpan="11">1.5</td>
            </tr>
            <tr>
              <td>Tirajul necesar al gazelor arse</td>
              <td>Pa</td>
              <td colSpan="11">60-80</td>
            </tr>
            <tr>
              <td>Temperatura gazelor arse la evacuare</td>
              <td>°C</td>
              <td colSpan="11">100-180</td>
            </tr>
            <tr>
              <td>Temperatura apei minim recomandată</td>
              <td>°C</td>
              <td colSpan="11">58</td>
            </tr>
            <tr>
              <td>Temperatura maximă a apei</td>
              <td>°C</td>
              <td colSpan="11">85</td>
            </tr>
            <tr>
              <td>Presiunea nominală a apei (maxim)</td>
              <td>MPa</td>
              <td colSpan="11">0.30</td>
            </tr>
            <tr>
              <td>Presiunea de testare a apei</td>
              <td>mPa</td>
              <td colSpan="11">0.45</td>
            </tr>
            <tr>
              <td>Consum de energie electrică, minim</td>
              <td>kW</td>
              <td>1.5</td>
              <td>1.6</td>
              <td>1.6</td>
              <td>1.6</td>
              <td>1.6</td>
              <td>1.7</td>
              <td>1.8</td>
              <td>2.1</td>
              <td>2.5</td>
              <td>2.6</td>
              <td>2.6</td>
            </tr>
            <tr>
              <td>Tensiunea rețelei</td>
              <td>—</td>
              <td colSpan="11">380 V (50 Hz)</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan="13">Parametri recomandați cos</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Secțiunea transversală</td>
              <td>cm²</td>
              <td>660</td>
              <td>660</td>
              <td>908</td>
              <td>1194</td>
              <td>1520</td>
              <td>1885</td>
              <td>2290</td>
              <td>2290</td>
              <td>2290</td>
              <td>2290</td>
              <td>2290</td>
            </tr>
            <tr>
              <td>Diametru intern</td>
              <td>mm</td>
              <td>300</td>
              <td>300</td>
              <td>350</td>
              <td>400</td>
              <td>450</td>
              <td>500</td>
              <td>550</td>
              <td>550</td>
              <td>550</td>
              <td>550</td>
              <td>550</td>
            </tr>
            <tr>
              <td>Înălțime (minim permisă)</td>
              <td>m</td>
              <td>7</td>
              <td>9</td>
              <td>9</td>
              <td>10</td>
              <td>12</td>
              <td>13</td>
              <td>14</td>
              <td>15</td>
              <td>18</td>
              <td>21</td>
              <td>27</td>
            </tr>
            <tr>
              <td>Diametru coatelor de alimentare a apei directă și a rețelei inverse (Du)</td>
              <td>mm</td>
              <td>65</td>
              <td>65</td>
              <td>65</td>
              <td>65</td>
              <td>80</td>
              <td>80</td>
              <td>80</td>
              <td>80</td>
              <td>100</td>
              <td>100</td>
              <td>100</td>
            </tr>
            <tr>
              <td>Diametru țevii de sub siguranțele supapei (Du)</td>
              <td>mm</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>2×50</td>
              <td>2×50</td>
              <td>2×50</td>
              <td>2×50</td>
              <td>2×50</td>
              <td>2×65</td>
            </tr>
            <tr>
              <td>Presiunea la care se activează siguranța supapei</td>
              <td>mPa</td>
              <td colSpan="12">0,35</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export const BioDimensions = () => {
  const data = [
    { param: 'B', unit: 'mm', values: [1360, 1360, 1440, 1440, 1490, 1690, 1690, 1690, 1730, 1730, 1730] },
    { param: 'B1', unit: 'mm', values: [1090, 1090, 1170, 1170, 1330, 1530, 1530, 1530, 1570, 1570, 1570] },
    { param: 'D', unit: 'mm', values: [298, 298, 348, 398, 448, 498, 548, 548, 548, 548, 548] },
    { param: 'H', unit: 'mm', values: [1840, 1840, 1990, 1990, 2300, 2500, 2500, 2500, 2500, 2500, 2500] },
    { param: 'H1', unit: 'mm', values: [1700, 1700, 1850, 1850, 2160, 2360, 2360, 2360, 2360, 2360, 2360] },
    { param: 'H2', unit: 'mm', values: [1383, 1384, 1530, 1530, 1806, 1931, 1956, 1956, 1956, 1956, 1956] },
    { param: 'H3', unit: 'mm', values: [402, 403, 402, 402, 403, 403, 403, 403, 413, 413, 413] },
    { param: 'L', unit: 'mm', values: [1890, 1980, 1980, 2380, 2480, 2500, 2720, 2830, 2920, 3120, 3320] },
    { param: 'L1', unit: 'mm', values: [1045, 1135, 1135, 1535, 1535, 1535, 1735, 1845, 1955, 2155, 2355] },
    { param: 'L2', unit: 'mm', values: [124, 126, 126, 126, 145, 145, 145, 145, 145, 145, 145] },
    { param: 'L3', unit: 'mm', values: [762, 848, 848, 1248, 1220, 970, 1170, 1282, 1370, 1570, 1770] },
  ];

  const headers = ['Parametri', 'U.M.', '100 kW', '150 kW', '200 kW', '250 kW', '300 kW', '400 kW', '500 kW', '600 kW', '700 kW', '800 kW', '1000 kW'];

  return (
    <div className={styles.dimensionsContainer}>
      <div className={styles.imageContainer}>
        <img src="/Dimensions/BioSchema.png" alt="Descriptive Alt Text" className={styles.centeredImage} />
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{row.param}</td>
                <td>{row.unit}</td>
                {row.values.map((value, valueIndex) => (
                  <td key={valueIndex}>{value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};


